'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _swiper = require('swiper');

var _swiperReact = require('swiper/react/swiper-react');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var defaultPaginationOptions = {
  bulletClass: 'car-Pagination_Bullet',
  bulletActiveClass: 'car-Pagination_Bullet-active',
  currentClass: 'car-Pagination_Bullet-current'
};

var Carousel = function Carousel(_ref) {
  var className = _ref.className,
      slideClassName = _ref.slideClassName,
      useNavigation = _ref.useNavigation,
      usePagination = _ref.usePagination,
      children = _ref.children,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'slideClassName', 'useNavigation', 'usePagination', 'children']);

  var modules = [].concat((0, _toConsumableArray3.default)(useNavigation ? [_swiper.Navigation] : []), (0, _toConsumableArray3.default)(usePagination ? [_swiper.Pagination] : []));

  if (children.length > 5) {
    defaultPaginationOptions.dynamicBullets = true;
    defaultPaginationOptions.dynamicMainBullets = 3;
  }
  var useProps = (0, _assign2.default)({
    modules: modules,
    navigation: useNavigation,
    pagination: usePagination && defaultPaginationOptions,
    centeredSlides: true,
    spaceBetween: 0,
    loop: true
  }, props);

  if (!children.length) return null;

  return _react2.default.createElement(_swiperReact.Swiper, (0, _extends3.default)({
    className: (0, _classnames2.default)('car-Container', className, {
      'car-Container-pagination-below': usePagination === 'below'
    })
  }, useProps), children.map(function (slide, index) {
    return _react2.default.createElement(_swiperReact.SwiperSlide, { className: (0, _classnames2.default)(slideClassName), key: index }, slide);
  }));
};
exports.Carousel = Carousel;